import { DxoUiHeader } from './src/DxoUiHeader';
import { DxoUiHeaderMobileMenu } from './src/dxo-ui-header-mobile-menu/DxoUiHeaderMobileMenu';

export { DxoUiHeader } from './src/DxoUiHeader';
export { DxoUiHeaderMobileMenu } from './src/dxo-ui-header-mobile-menu/DxoUiHeaderMobileMenu';

const ElementRegistered = window.customElements.get('dxo-ui-header');

if (!ElementRegistered) {
  window.customElements.define('dxo-ui-header', DxoUiHeader as any);
}

if (!window.customElements.get('dxo-ui-header-mobile-menu')) {
  window.customElements.define('dxo-ui-header-mobile-menu', DxoUiHeaderMobileMenu as any);
}